import React from 'react';
import { FaWhatsapp, FaPhone } from 'react-icons/fa';
import { CONTACT_LINK_WHATSAPP, CONTACT_PHONE_LINK } from '../constants';
import { setShowDialog2 } from '../state/slices';
import { useDispatch } from 'react-redux';
import StaticPool from '../state/static_pool';

const FloatingContactButtons = () => {
  const dispatch = useDispatch();

  const buttonStyle = {
    width: '50px',
    height: '50px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.2)',
    color: 'white',
    fontSize: '24px',
  };

  const styleValue = {
    position: 'fixed',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '10px',
    zIndex: 1000,
    cursor: 'pointer',
  };

  return (
    <div style={styleValue}>
      <div
        onClick={() => {
          StaticPool.setActionType('phone');
          document.body.style.overflow = 'hidden';
          dispatch(setShowDialog2(true));
        }}
        style={{ ...buttonStyle, backgroundColor: 'white' }} // Blue for phone
      >
        <FaPhone style={{ height: '20px', width: '30px', color: '007bff', transform: 'scaleX(-1)' }} />
      </div>
      <div
        onClick={() => {
          StaticPool.setActionType('whatsapp');
          document.body.style.overflow = 'hidden';
          dispatch(setShowDialog2(true));
        }}
        target="_blank"
        rel="noopener noreferrer"
        style={{ ...buttonStyle, backgroundColor: '#25D366' }}
      >
        <FaWhatsapp style={{ height: '30px', width: '30px' }} />
      </div>
    </div>
  );
};

export default FloatingContactButtons;
